import { any, bool } from 'prop-types';
import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';

import { CheckboxFilledIcon } from 'components/Icons';

const CheckMarkContainerStyled = styled.div`
    align-items: center;
    display: flex;
    width: 20px;
`;

const OptionStyled = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 100%;
`;

const MultiSelectOption = ({ children, ...props }) => {
    return (
        <components.Option {...props}>
            <OptionStyled>
                <CheckMarkContainerStyled>
                    {props.isSelected && <CheckboxFilledIcon backgroundFill="transparent" />}
                </CheckMarkContainerStyled>
                {children}
            </OptionStyled>
        </components.Option>
    );
};

MultiSelectOption.propTypes = {
    children: any.isRequired,
    isSelected: bool.isRequired,
};

export default MultiSelectOption;
